var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskGauge5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 70,
    viewBox: "0 0 138 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_38641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383209 64.0531 1.54437 57.4861C3.99124 43.6478 10.628 30.782 20.7004 20.7096C33.6404 7.76962 51.1908 0.500002 69.4907 0.5C87.7906 0.499998 105.341 7.76962 118.281 20.7096C128.353 30.782 134.99 43.6478 137.437 57.4861C138.598 64.0531 133.085 69.5 126.416 69.5C119.747 69.5 114.499 63.9986 112.725 57.57C110.679 50.1544 106.74 43.3214 101.204 37.7863C92.7934 29.3753 81.3857 24.65 69.4907 24.65C57.5958 24.65 46.188 29.3753 37.777 37.7863C32.2418 43.3214 28.3029 50.1544 26.2564 57.57C24.4823 63.9986 19.2346 69.5 12.5657 69.5Z",
    fill: "#D5D6D8",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383496 64.0534 1.54461 57.4865C2.41518 52.5627 3.82044 47.7364 5.74304 43.0948C9.21061 34.7234 14.2931 27.1169 20.7004 20.7096C27.1076 14.3024 34.7141 9.21988 43.0856 5.75231C51.457 2.28474 60.4295 0.499999 69.4907 0.5C78.5519 0.500001 87.5244 2.28474 95.8959 5.75232C104.267 9.21989 111.874 14.3024 118.281 20.7096C124.688 27.1169 129.771 34.7234 133.238 43.0949C135.161 47.7364 136.566 52.5627 137.437 57.4865C138.598 64.0535 133.085 69.5 126.416 69.5C119.747 69.5 114.499 63.9989 112.725 57.5703C112.235 55.7941 111.635 54.0461 110.927 52.3367C108.673 46.8952 105.369 41.951 101.204 37.7863C97.0398 33.6216 92.0955 30.3179 86.6541 28.064C81.2126 25.8101 75.3805 24.65 69.4907 24.65C63.6009 24.65 57.7688 25.8101 52.3274 28.064C46.8859 30.3179 41.9417 33.6216 37.777 37.7863C33.6123 41.951 30.3087 46.8952 28.0547 52.3366C27.3467 54.0461 26.7465 55.7941 26.2564 57.5703C24.4826 63.9989 19.2346 69.5 12.5657 69.5Z",
    fill: "#28245C",
    style: {
      fill: "#28245C",
      fill: "color(display-p3 0.1569 0.1412 0.3608)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383496 64.0534 1.54461 57.4865C2.41518 52.5627 3.82044 47.7364 5.74304 43.0948C9.21061 34.7234 14.2931 27.1169 20.7004 20.7096C27.1076 14.3024 34.7141 9.21988 43.0856 5.75231C51.457 2.28474 60.4295 0.499999 69.4907 0.5C78.5519 0.500001 87.5244 2.28474 95.8959 5.75232C104.267 9.21989 111.874 14.3024 118.281 20.7096C124.688 27.1169 129.771 34.7234 133.238 43.0949C135.161 47.7364 136.566 52.5627 137.437 57.4865C138.598 64.0535 133.085 69.5 126.416 69.5C119.747 69.5 114.499 63.9989 112.725 57.5703C112.235 55.7941 111.635 54.0461 110.927 52.3367C108.673 46.8952 105.369 41.951 101.204 37.7863C97.0398 33.6216 92.0955 30.3179 86.6541 28.064C81.2126 25.8101 75.3805 24.65 69.4907 24.65C63.6009 24.65 57.7688 25.8101 52.3274 28.064C46.8859 30.3179 41.9417 33.6216 37.777 37.7863C33.6123 41.951 30.3087 46.8952 28.0547 52.3366C27.3467 54.0461 26.7465 55.7941 26.2564 57.5703C24.4826 63.9989 19.2346 69.5 12.5657 69.5Z",
    fill: "url(#grad5)",
    style: {},
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 58,
    r: 7,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad5",
    x1: "0%",
    y1: "0%",
    x2: "90%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF865D"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_38641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 69,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskGauge5);
export default __webpack_public_path__ + "static/media/risk-gauge-5.3cc6fbc13d177adc98e2c0bff042a145.svg";
export { ForwardRef as ReactComponent };